import { Directive, ElementRef, AfterViewInit, Input, Renderer2 } from '@angular/core';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
@Directive({
    standalone: false,
    selector: '[cvaTrimText]',
    
})
export class TrimTextDirective extends NgbPopover implements AfterViewInit {

  private readonly  POPOVER_CLASS_NAME = 'long-text-popover';

  @Input('cvaTrimText') content!: string;
  @Input() maxLength: number = 100;
  @Input() title: string = 'Reason';

  constructor(private readonly  el: ElementRef, private readonly  renderer: Renderer2) {
    super();
  }

  ngAfterViewInit() {
    this.trimContent(this.content);
  }

  private trimContent(content: string = '') {
    content = content || this.el.nativeElement.textContent.trim();

    if (content.length > this.maxLength) {
      const trimmedText = content.substring(0, this.maxLength) + '...';

      //setting up the popover details
      this.popoverTitle = this.title;
      this.ngbPopover = content;
      this.triggers = 'manual';
      this.popoverClass = this.POPOVER_CLASS_NAME;
      this.container='body';

      //set the property into DOM
      this.renderer.setProperty(this.el.nativeElement, 'textContent', trimmedText);
      this.renderer.setStyle(this.el.nativeElement, 'cursor', 'pointer');     
    } else {
      this.renderer.setProperty(this.el.nativeElement, 'textContent', content);
      this.renderer.setStyle(this.el.nativeElement, 'cursor', 'auto');  
    }

    this.renderer.listen(this.el.nativeElement, 'click', (event) => {
      event.stopPropagation();
    });
  }
}
